import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Typography } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PolicyIcon from '@mui/icons-material/Policy';
import { useNavigate } from 'react-router-dom';
import ContactUsForm from './ContactUsForm';
import paths from '../../lib/consts/paths';

import FaqList from '../Landing/FaqList';
import './ContactUsPage.scss';
import Footer from '../Home/Footer';

const ContactUs: FC = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();

	return (
		<div className="ContactUs">
			<div className="ContactUs__wrapper">
				<div className="ContactUs__cols">
					<div className="ContactUs__form">
						{/* <img
							src="https://static.codeway.today/image/1705867324919.png"
							alt="contact us"
						/> */}
						<Typography
							variant="h3"
							component="h1"
							className="ContactUs__title"
							sx={{ fontWeight: '600' }}
						>
							{t('FAQ')}
						</Typography>
						<FaqList />
					</div>
					<div className="ContactUs__form">
						<div>
							{/* <h1 className="ContactUs__title page-title">{t('contactUs')}</h1> */}
							<Typography
								variant="h3"
								component="h1"
								className="ContactUs__title"
								sx={{ fontWeight: '600' }}
							>
								{t('contactUs')}
							</Typography>
							<ContactUsForm />
						</div>
						<div className="contacts">
							<div className="contacts__col">
								<div>
									<Typography
										variant="h6"
										className="contacts__title"
										sx={{ fontWeight: '600' }}
									>
										<EmailIcon sx={{ marginRight: '5px' }} color="secondary" />
										Email
									</Typography>
									<Typography variant="body1">codeway.today@gmail.com</Typography>
								</div>
								<div>
									<Typography
										variant="h6"
										className="contacts__title"
										sx={{ fontWeight: '600' }}
									>
										<LocationOnIcon sx={{ marginRight: '5px' }} color="secondary" />
										Address
									</Typography>
									<Typography variant="body1">Talin, Avenue road str. 24/12</Typography>
								</div>
							</div>
							<div className="contacts__col">
								<div>
									<Typography
										variant="h6"
										className="contacts__title"
										sx={{ fontWeight: '600' }}
									>
										<PolicyIcon sx={{ marginRight: '5px' }} color="secondary" />
										Policies
									</Typography>
									<Typography
										variant="body1"
										className="contact-link"
										onClick={() => navigate(paths.privacyPolicy)}
									>
										Privacy policy <OpenInNewIcon fontSize="small" color="primary" />
									</Typography>
									<Typography
										variant="body1"
										className="contact-link"
										onClick={() => navigate(paths.termsAndConditions)}
									>
										Terms and conditions{' '}
										<OpenInNewIcon fontSize="small" color="primary" />
									</Typography>
									<Typography
										variant="body1"
										className="contact-link"
										onClick={() => navigate(paths.cookiesInfo)}
									>
										Cookie policy <OpenInNewIcon fontSize="small" color="primary" />
									</Typography>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<Footer />
		</div>
	);
};

export default ContactUs;
